import React from "react";

export const ResultsLoading: React.FC = () => {
    return (
        <div className="product-grid-loading row small-up-2 medium-up-4">
            <ProductLoadingPlaceholder />
            <ProductLoadingPlaceholder />
            <ProductLoadingPlaceholder />
            <ProductLoadingPlaceholder />
        </div>
    );
};

const ProductLoadingPlaceholder: React.FC = () => {
    return (
        <div className="product-grid-placeholder">
            <div className="animated-background"></div>
        </div>
    )
}